import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CartType } from "../../types/cartItemType";
import { api } from "../../config/Api";
import { CouponState } from "../../types/couponType";


interface CouponAplyReq{
    apply:string,
    code:string,
    orderValue:number;
}
const BASE_URL= "/api/coupon"
export const applyCoupon = createAsyncThunk<CartType,CouponAplyReq,{rejectValue:string}>(
    "coupon/applyCoupon",
    async(couponReq,{rejectWithValue})=>{
      try {
        // null is in the middle represent for empty body
        const response = await api.post(`${BASE_URL}/apply`,null,
            {params: couponReq}
        )
        return response.data
      } catch (error:any) {
     
        rejectWithValue(error.response.data.message||"FAILED TO APPLY COUPON")
      }
    }
)

const initialState:CouponState={
    coupons:[],
    cart:null,
    loading:false,
    error:null,
    couponCreated:false,
    couponApplied:false
}

const couponSlice = createSlice({
    name:"coupon",
    initialState,
    reducers:{},
    extraReducers:(builder) => { 
        builder.addCase(applyCoupon.pending,(state)=>{
            state.loading=true;
            state.error=null;
            state.couponApplied=false;
        })
        .addCase(applyCoupon.fulfilled,(state,action)=>{
            state.loading=false;
         
            if(action.meta.arg.apply==="true"){
                state.couponApplied=true
            }
        })
        .addCase(applyCoupon.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.payload;
        })
     }
})

export const couponSliceReducer =couponSlice.reducer
